import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const sysConfig = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [

        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.name || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
        },
        {
            title: '配置键',
            dataIndex: 'confKey',
            key: 'confKey'
        },
        {
            title: '配置值',
            dataIndex: 'confValue',
            key: 'confValue',
            scopedSlots: { customRender: 'confValue' },
        },
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 200
        },    ]
}
